// src/components/pages/EventManager/EventContentPage.js

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Typography, Box } from "@mui/material";
import { useTheme } from "styled-components";
import ChallengeList from "./organisms/ChallengeList";
import ContentList from "./organisms/ContentList";

const EventContentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { event } = location.state || {};
  const theme = useTheme();

  if (!event?.id) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, fontFamily: "basic-sans" }}>
        <Typography variant="h5" color="error">
          No event was provided.
        </Typography>
        <Box mt={2}>
          <Typography
            onClick={() => navigate("/challenge/admin/events")}
            sx={{
              color: theme.colors.amber,
              cursor: "pointer",
              textDecoration: "underline",
              fontFamily: "basic-sans",
            }}
          >
            Go back to Events
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, fontFamily: "basic-sans" }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: 300, fontFamily: "basic-sans", mb: 4 }}
      >
        Edit & Add Content for "{event.title || "Event"}"
      </Typography>

      {/* Current content + Manual assets */}
      <ContentList theme={theme} event={event} />

      {/* Select content from Challenges */}
      <ChallengeList theme={theme} event={event} />
    </Container>
  );
};

export default EventContentPage;
